<template>

  <section class="road-map">

    <div class="blex w-full pb-0 pl-16 lg:pl-0 bg-black relative">

      <div class="blex bg-black w-full mb-40 lg:mb-100">
        <div class="text-white font-bold text-2xl lg:text-6xl blex lg:pt-210 bottom-gradient pb-12">
          ROADMAP
        </div>
      </div>

      <!-- @todo : 스크롤을 내렸을 시, 'on' class 추가     -->
      <div class="line-center"></div>

      <div
          class="blex lg:justify-center items-start justify-start w-full flex-no-wrap overflow-x-auto road-wrapper scroll-bar-hidden">
        <!-- 2022       -->
        <div class="road-circle item1">
          <img src="@/assets/images/pages/main/roadMap/roadMapCircle.svg" class="circle-image">
          <div class="year">
            2022
          </div>

          <!-- @todo : 스크롤을 내렸을 시, 'on' class 추가     -->
          <div class="vertical-radient">
            <div class="blex-left pb-24">
              <div class="w-full text-white font-semiBold text-2xs lg:text-lg relative dot">
                METAVERSE RELEASE 0.1
              </div>
              <div class="text-gray leading-xs font-medium text-3xs lg:text-base">
                MetaRising ECOSYSTEM BEGINS
              </div>
            </div>
            <div class="text-light-gray font-base text-3xs lg:text-base leading-xs">
              NFT Minting page<br>
              Seed NFTs<br>
              MCT Vesting Smart Contract<br>
              SeedBox Platform 4.0 Upgrade<br>
              MetaRising Website Launch<br>
              Pet NFTs<br>

            </div>
          </div>
        </div>
        <!-- 2023. Q1       -->
        <div class="road-circle item2">
          <img src="@/assets/images/pages/main/roadMap/roadMapCircle.svg" class="circle-image">
          <div class="year">
            2023. Q1
          </div>
          <div class="vertical-radient">
            <div class="blex-left pb-24">
              <div class="w-full text-white font-semiBold text-2xs lg:text-lg relative dot">
                SEEDBOX VERSION 4.0
              </div>
              <div class="text-gray leading-xs font-medium text-3xs lg:text-base">
                MetaRising INTEGRATION
              </div>
            </div>
            <div class="text-light-gray font-base text-3xs lg:text-base leading-xs">
              Cross Promotion and Partnerships<br>
              NFT Marketplace Launch<br>
              NFT Staking<br>
              NFT Airdrop<br>
              Vehicle NFTs<br>
            </div>
          </div>
        </div>
        <!-- 2023. Q2       -->
        <div class="road-circle item3">
          <img src="@/assets/images/pages/main/roadMap/roadMapCircle.svg" class="circle-image">
          <div class="year">
            2023. Q2
          </div>

          <!-- @todo : 스크롤을 내렸을 시, 'on' class 추가     -->
          <div class="vertical-radient">
            <div class="blex-left pb-24">
              <div class="w-full text-white font-semiBold text-2xs lg:text-lg relative dot">
                METAVERSE RELEASE 0.2
              </div>
              <div class="text-gray leading-xs font-medium text-3xs lg:text-base">
                ALPHA
              </div>
            </div>
            <div class="text-light-gray font-base text-3xs lg:text-base leading-xs">
              Closed Alpha Test<br>
              1ST Climate Change Summit in ‘MetaRising’<br>
              NFT Sale – PFP, Farming Tool<br>
              NFT Mystery Box<br>
              Avatar Customization<br>
              C2E Zone - Farming (crop)<br>
              C2E Zone - Farming (animal)<br>
            </div>
          </div>
        </div>
        <!-- 2023. Q3       -->
        <div class="road-circle item4">
          <img src="@/assets/images/pages/main/roadMap/roadMapCircle.svg" class="circle-image">
          <div class="year">
            2023. Q3
          </div>

          <!-- @todo : 스크롤을 내렸을 시, 'on' class 추가     -->
          <div class="vertical-radient">
            <div class="blex-left pb-24">
              <div class="w-full text-white font-semiBold text-2xs lg:text-lg relative dot">
                METAVERSE RELEASE 0.3
              </div>
              <div class="text-gray leading-xs font-medium text-3xs lg:text-base">
                BETA
              </div>
            </div>
            <div class="text-light-gray font-base text-3xs lg:text-base leading-xs">
              Beta Test<br>
              Multiverse NFT Integration – ‘WonderKing’<br>
              NFT Sale – Land<br>
              C2E DApp – Carbon Finance<br>
              User Generated Content World<br>
              C2E Zone - Ocean (Fishing)<br>
              C2E Zone - Cave (Mining)<br>
              Guild System<br>
              Dual DAO Governance<br>
            </div>
          </div>
        </div>
      </div>

    </div>

  </section>

</template>

<script>
let timeline = null
export default {
  name: 'RoadMap',
  data: () => ({}),
  methods: {
    animations() {
      timeline = this.$gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: 'section.road-map',
          scroller: '#index',
          start: 'top 100px',
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none'
        }
      })

      timeline.to('.line-center', {
        duration: 1,
        className: 'on line-center'
      }).to('.vertical-radient', {
        duration: 1,
        className: 'on vertical-radient'
      }, '-=1')

      // this.$scrollTrigger.refresh()
    }
  },
  beforeDestroy() {
    if (timeline) {
      timeline.kill()
    }
  }
}
</script>

<style scoped lang="scss">
section::v-deep {

  .line-center {
    position: absolute;
    top: 41%;
    width: 0;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(to right, #000000, #ffffff, #000000);
    }

    &.on {
      animation: leftToRight 2s linear forwards;
    }

    @media screen and (max-width: 1024px) {
      top: 19%;
    }
  }

  @keyframes leftToRight {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

  .road-wrapper {
    min-height: 700px;
    @media screen and (max-width: 1024px) {
      min-height: 530px;
    }


    .road-circle {
      position: relative;
      width: 105px;
      height: 105px;
      margin-right: 15vw;
      @media screen and (max-width: 1024px) {
        width: 60px;
        height: 60px;
        margin-right: 180px;
      }

      .circle-image {
        width: 105px;
        @media screen and (max-width: 1024px) {
          width: 60px;
        }
      }

      .year {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        font-weight: 500;
        font-size: 20px;
        @media screen and (max-width: 1024px) {
          font-size: 12px;
        }
      }

      .vertical-radient {
        position: absolute;
        left: 50%;
        padding: 0 24px;
        width: 300px;
        height: 0;

        &.on {
          animation: topToBottom 1s linear forwards;
        }

        &::before {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 1px;
          height: 100%;
          background: linear-gradient(to bottom, #000000, #ffffff, #000000);

        }

        @keyframes topToBottom {
          0% {
            height: 0;
          }
          100% {
            height: 500px;
          }
        }

        @media screen and (max-width: 1024px) {

          width: 250px;
          height: 0;

          @keyframes topToBottom {
            0% {
              height: 0;
            }
            100% {
              height: 400px;
            }
          }

        }


        .dot {
          position: relative;

          &::after {
            content: '';
            position: absolute;
            width: 8px;
            height: 8px;
            background-color: #fff;
            border-radius: 50%;
            left: -28px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

    }

  }


}

</style>
